import {Language} from "../../../languages";

export default [
    Language.English,
    Language.French,
    Language.Spanish,
    Language.Dutch,
    Language.PortugueseBrazil,
];